module.exports = "https://static.wanderu.com/static/media/google-store.04d46ab8.png";